/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SmsUtilitaireSearch
 */
export interface SmsUtilitaireSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof SmsUtilitaireSearch
     */
    description?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SmsUtilitaireSearch
     */
    creationDate?: DateSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SmsUtilitaireSearch
     */
    dateEnvoi?: DateSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SmsUtilitaireSearch
     */
    centre?: Int32ListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof SmsUtilitaireSearch
     */
    anneeScolaire?: StringListSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SmsUtilitaireSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SmsUtilitaireSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SmsUtilitaireSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SmsUtilitaireSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SmsUtilitaireSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SmsUtilitaireSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SmsUtilitaireSearch interface.
 */
export function instanceOfSmsUtilitaireSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmsUtilitaireSearchFromJSON(json: any): SmsUtilitaireSearch {
    return SmsUtilitaireSearchFromJSONTyped(json, false);
}

export function SmsUtilitaireSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsUtilitaireSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : TextSearchFromJSON(json['description']),
        'creationDate': !exists(json, 'creationDate') ? undefined : DateSearchFromJSON(json['creationDate']),
        'dateEnvoi': !exists(json, 'dateEnvoi') ? undefined : DateSearchFromJSON(json['dateEnvoi']),
        'centre': !exists(json, 'centre') ? undefined : Int32ListSearchFromJSON(json['centre']),
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : StringListSearchFromJSON(json['anneeScolaire']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SmsUtilitaireSearchToJSON(value?: SmsUtilitaireSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': TextSearchToJSON(value.description),
        'creationDate': DateSearchToJSON(value.creationDate),
        'dateEnvoi': DateSearchToJSON(value.dateEnvoi),
        'centre': Int32ListSearchToJSON(value.centre),
        'anneeScolaire': StringListSearchToJSON(value.anneeScolaire),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

